import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ChecklistItem} from '../../models/checklist-item';

@inheritSerialization(LoadableState)
export class ChecklistItemsState extends LoadableState {
  public static readonly key = 'ChecklistItemsState';

  @autoserializeAs(ChecklistItem, 'checklistItems')
  public checklistItems: ChecklistItem[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;
}
